import { css } from '@emotion/react/macro'

import mediaQuery from 'share/utils/mediaQuery'

const flexCenter = css`
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`

const pageContentDefaultSize = css`
  margin-left: auto;
  margin-right: auto;
  max-width: 576px;
  text-align: left;
  width: 100%;

  ${mediaQuery('mobile')} {
    padding-left: 16px;
    padding-right: 16px;
    padding-inline: 16px;
  }

  ${mediaQuery('tablet', 'mobile')} {
    max-width: 548px;
  }
`

const btnMaxSizes = css`
  width: 100%;

  ${mediaQuery('tablet', 'mobile')} {
    max-width: 266px;
  }

  ${mediaQuery('', 'tablet')} {
    max-width: 380px;
  }
`

const defaultTopMargin = css`
  margin-top: 48px;

  ${mediaQuery('tablet')} {
    margin-top: 24px;
  }
`

export { btnMaxSizes, defaultTopMargin, flexCenter, pageContentDefaultSize }
